//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class EducationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:6501";

    }

    getExams( cancelToken?: CancelToken): Promise<EducationExamResponseModel[]> {
        let url_ = this.baseUrl + "/api/education/exams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExams(_response);
        });
    }

    protected processGetExams(response: AxiosResponse): Promise<EducationExamResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EducationExamResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EducationExamResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EducationExamResponseModel[]>(null as any);
    }

    getUserExamDescription(examId: number, cancelToken?: CancelToken): Promise<ExamDescriptionModel> {
        let url_ = this.baseUrl + "/api/education/exams/{examId}/description";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserExamDescription(_response);
        });
    }

    protected processGetUserExamDescription(response: AxiosResponse): Promise<ExamDescriptionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExamDescriptionModel.fromJS(resultData200);
            return Promise.resolve<ExamDescriptionModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamDescriptionModel>(null as any);
    }
}

export class ExamActionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:6501";

    }

    startExam(examId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/examactions/start/{examId}";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartExam(_response);
        });
    }

    protected processStartExam(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    finishExam(examId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/examactions/finish/{examId}";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFinishExam(_response);
        });
    }

    protected processFinishExam(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ExamCountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:6501";

    }

    getExamCount(model: ExamCountPostModel, cancelToken?: CancelToken): Promise<ExamCountResultModel[]> {
        let url_ = this.baseUrl + "/api/exams-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExamCount(_response);
        });
    }

    protected processGetExamCount(response: AxiosResponse): Promise<ExamCountResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExamCountResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ExamCountResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamCountResultModel[]>(null as any);
    }
}

export class ExamDataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:6501";

    }

    getExamData(examId: number, cancelToken?: CancelToken): Promise<ExamDataRowResultModel[]> {
        let url_ = this.baseUrl + "/api/examdata/{examId}";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExamData(_response);
        });
    }

    protected processGetExamData(response: AxiosResponse): Promise<ExamDataRowResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExamDataRowResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ExamDataRowResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamDataRowResultModel[]>(null as any);
    }

    generateExamData(examId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/examdata/generate/{examId}";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateExamData(_response);
        });
    }

    protected processGenerateExamData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    generateExamPDFs(examId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/examdata/generate-pdfs/{examId}";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateExamPDFs(_response);
        });
    }

    protected processGenerateExamPDFs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    checkDoesExamPDFsFolderExists(examId: number, cancelToken?: CancelToken): Promise<ExamPDFsFolderExistsResponseModel> {
        let url_ = this.baseUrl + "/api/examdata/generate-pdfs/{examId}/folder-check";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckDoesExamPDFsFolderExists(_response);
        });
    }

    protected processCheckDoesExamPDFsFolderExists(response: AxiosResponse): Promise<ExamPDFsFolderExistsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExamPDFsFolderExistsResponseModel.fromJS(resultData200);
            return Promise.resolve<ExamPDFsFolderExistsResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamPDFsFolderExistsResponseModel>(null as any);
    }

    getExamTemplateForRow(examId: number, rowId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/examdata/templates/{examId}/row-data/{rowId}";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        if (rowId === undefined || rowId === null)
            throw new Error("The parameter 'rowId' must be defined.");
        url_ = url_.replace("{rowId}", encodeURIComponent("" + rowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExamTemplateForRow(_response);
        });
    }

    protected processGetExamTemplateForRow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ExamImagesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:6501";

    }

    upload(upload: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/exam-images/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (upload !== null && upload !== undefined)
            content_.append("upload", upload.data, upload.fileName ? upload.fileName : "upload");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getImage(uniqueIdentifier: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/exam-images/{uniqueIdentifier}";
        if (uniqueIdentifier === undefined || uniqueIdentifier === null)
            throw new Error("The parameter 'uniqueIdentifier' must be defined.");
        url_ = url_.replace("{uniqueIdentifier}", encodeURIComponent("" + uniqueIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImage(_response);
        });
    }

    protected processGetImage(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ExamsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:6501";

    }

    createOrUpdateExam(model: ExamPostModel, cancelToken?: CancelToken): Promise<ExamCreatedResultModel> {
        let url_ = this.baseUrl + "/api/exams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateExam(_response);
        });
    }

    protected processCreateOrUpdateExam(response: AxiosResponse): Promise<ExamCreatedResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExamCreatedResultModel.fromJS(resultData200);
            return Promise.resolve<ExamCreatedResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamCreatedResultModel>(null as any);
    }

    getExams(fileDriveId: string | null | undefined, cancelToken?: CancelToken): Promise<ExamResultModel[]> {
        let url_ = this.baseUrl + "/api/exams?";
        if (fileDriveId !== undefined && fileDriveId !== null)
            url_ += "FileDriveId=" + encodeURIComponent("" + fileDriveId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExams(_response);
        });
    }

    protected processGetExams(response: AxiosResponse): Promise<ExamResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExamResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ExamResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamResultModel[]>(null as any);
    }

    getExam(id: number, cancelToken?: CancelToken): Promise<ExamPostModel> {
        let url_ = this.baseUrl + "/api/exams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExam(_response);
        });
    }

    protected processGetExam(response: AxiosResponse): Promise<ExamPostModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExamPostModel.fromJS(resultData200);
            return Promise.resolve<ExamPostModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamPostModel>(null as any);
    }

    deleteExam(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/exams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExam(_response);
        });
    }

    protected processDeleteExam(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    restoreExam(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/exams/{id}/restore";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreExam(_response);
        });
    }

    protected processRestoreExam(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getStudentExam(id: number, cancelToken?: CancelToken): Promise<ExamPostModel> {
        let url_ = this.baseUrl + "/api/exams/{id}/student";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudentExam(_response);
        });
    }

    protected processGetStudentExam(response: AxiosResponse): Promise<ExamPostModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExamPostModel.fromJS(resultData200);
            return Promise.resolve<ExamPostModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamPostModel>(null as any);
    }

    getAllUserExams(skip: number | undefined, take: number | undefined, orderByIdDesc: boolean | undefined, cancelToken?: CancelToken): Promise<ExamListResponseModel> {
        let url_ = this.baseUrl + "/api/exams/all-user-exams?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (orderByIdDesc === null)
            throw new Error("The parameter 'orderByIdDesc' cannot be null.");
        else if (orderByIdDesc !== undefined)
            url_ += "OrderByIdDesc=" + encodeURIComponent("" + orderByIdDesc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUserExams(_response);
        });
    }

    protected processGetAllUserExams(response: AxiosResponse): Promise<ExamListResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExamListResponseModel.fromJS(resultData200);
            return Promise.resolve<ExamListResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamListResponseModel>(null as any);
    }

    exportExamToJsonFile(model: ExportExamToJsonPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/exams/export-to-json";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExamToJsonFile(_response);
        });
    }

    protected processExportExamToJsonFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    exportExamAnswers(examId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/exams/export-answers/{examId}";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExamAnswers(_response);
        });
    }

    protected processExportExamAnswers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    cloneExams(model: CloneExamsPostModel, cancelToken?: CancelToken): Promise<CloneExamsResponseModel> {
        let url_ = this.baseUrl + "/api/exams/clone-multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneExams(_response);
        });
    }

    protected processCloneExams(response: AxiosResponse): Promise<CloneExamsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CloneExamsResponseModel.fromJS(resultData200);
            return Promise.resolve<CloneExamsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloneExamsResponseModel>(null as any);
    }

    submitResults(model: SubmittedExamPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/exams/submitResults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitResults(_response);
        });
    }

    protected processSubmitResults(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSubmittedAnswers(examId: number, cancelToken?: CancelToken): Promise<SubmittedExamPostModel> {
        let url_ = this.baseUrl + "/api/exams/submitted-answers/{examId}";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubmittedAnswers(_response);
        });
    }

    protected processGetSubmittedAnswers(response: AxiosResponse): Promise<SubmittedExamPostModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubmittedExamPostModel.fromJS(resultData200);
            return Promise.resolve<SubmittedExamPostModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmittedExamPostModel>(null as any);
    }

    getExamStatus(examId: number, cancelToken?: CancelToken): Promise<ExamStatus> {
        let url_ = this.baseUrl + "/api/exams/{examId}/status";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExamStatus(_response);
        });
    }

    protected processGetExamStatus(response: AxiosResponse): Promise<ExamStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<ExamStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamStatus>(null as any);
    }
}

export class ServiceInformationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:6501";

    }

    getBuildDate( cancelToken?: CancelToken): Promise<ServiceInformationModel> {
        let url_ = this.baseUrl + "/api/serviceInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuildDate(_response);
        });
    }

    protected processGetBuildDate(response: AxiosResponse): Promise<ServiceInformationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceInformationModel.fromJS(resultData200);
            return Promise.resolve<ServiceInformationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceInformationModel>(null as any);
    }
}

export class EducationExamResponseModel implements IEducationExamResponseModel {
    id?: number;
    name?: string | undefined;
    date?: Date;
    startTime?: string | undefined;
    duration?: string | undefined;
    worksheet?: string | undefined;
    status?: ExamStatus;
    startedAt?: Date | undefined;
    userId?: string | undefined;
    fileDriveId?: string | undefined;

    constructor(data?: IEducationExamResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.startTime = _data["startTime"];
            this.duration = _data["duration"];
            this.worksheet = _data["worksheet"];
            this.status = _data["status"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.fileDriveId = _data["fileDriveId"];
        }
    }

    static fromJS(data: any): EducationExamResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new EducationExamResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["startTime"] = this.startTime;
        data["duration"] = this.duration;
        data["worksheet"] = this.worksheet;
        data["status"] = this.status;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["fileDriveId"] = this.fileDriveId;
        return data;
    }
}

export interface IEducationExamResponseModel {
    id?: number;
    name?: string | undefined;
    date?: Date;
    startTime?: string | undefined;
    duration?: string | undefined;
    worksheet?: string | undefined;
    status?: ExamStatus;
    startedAt?: Date | undefined;
    userId?: string | undefined;
    fileDriveId?: string | undefined;
}

export enum ExamStatus {
    Draft = 0,
    Started = 1,
    Finished = 2,
    Cancelled = 3,
}

export class ErrorResultModel implements IErrorResultModel {
    errorCode?: number | undefined;
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IErrorResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (_data["validationErrors"]) {
                this.validationErrors = {} as any;
                for (let key in _data["validationErrors"]) {
                    if (_data["validationErrors"].hasOwnProperty(key))
                        (<any>this.validationErrors)![key] = _data["validationErrors"][key] !== undefined ? _data["validationErrors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (this.validationErrors) {
            data["validationErrors"] = {};
            for (let key in this.validationErrors) {
                if (this.validationErrors.hasOwnProperty(key))
                    (<any>data["validationErrors"])[key] = (<any>this.validationErrors)[key];
            }
        }
        return data;
    }
}

export interface IErrorResultModel {
    errorCode?: number | undefined;
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;
}

export class ExamDescriptionModel implements IExamDescriptionModel {
    introduction?: string | undefined;
    exercises?: ExerciseDescriptionModel[] | undefined;

    constructor(data?: IExamDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.introduction = _data["introduction"];
            if (Array.isArray(_data["exercises"])) {
                this.exercises = [] as any;
                for (let item of _data["exercises"])
                    this.exercises!.push(ExerciseDescriptionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["introduction"] = this.introduction;
        if (Array.isArray(this.exercises)) {
            data["exercises"] = [];
            for (let item of this.exercises)
                data["exercises"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExamDescriptionModel {
    introduction?: string | undefined;
    exercises?: ExerciseDescriptionModel[] | undefined;
}

export class ExerciseDescriptionModel implements IExerciseDescriptionModel {
    id?: number;
    order?: number;
    subExerciseOrder?: number | undefined;
    description?: string | undefined;

    constructor(data?: IExerciseDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.subExerciseOrder = _data["subExerciseOrder"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ExerciseDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExerciseDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["subExerciseOrder"] = this.subExerciseOrder;
        data["description"] = this.description;
        return data;
    }
}

export interface IExerciseDescriptionModel {
    id?: number;
    order?: number;
    subExerciseOrder?: number | undefined;
    description?: string | undefined;
}

export class ExamCountResultModel implements IExamCountResultModel {
    driveItemId?: string | undefined;
    count?: number;

    constructor(data?: IExamCountResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driveItemId = _data["driveItemId"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ExamCountResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExamCountResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driveItemId"] = this.driveItemId;
        data["count"] = this.count;
        return data;
    }
}

export interface IExamCountResultModel {
    driveItemId?: string | undefined;
    count?: number;
}

export class ErrorResponseModel implements IErrorResponseModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IErrorResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (_data["validationErrors"]) {
                this.validationErrors = {} as any;
                for (let key in _data["validationErrors"]) {
                    if (_data["validationErrors"].hasOwnProperty(key))
                        (<any>this.validationErrors)![key] = _data["validationErrors"][key] !== undefined ? _data["validationErrors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (this.validationErrors) {
            data["validationErrors"] = {};
            for (let key in this.validationErrors) {
                if (this.validationErrors.hasOwnProperty(key))
                    (<any>data["validationErrors"])[key] = (<any>this.validationErrors)[key];
            }
        }
        return data;
    }
}

export interface IErrorResponseModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;
}

export class ExamCountPostModel implements IExamCountPostModel {
    driveItemIds?: string[] | undefined;

    constructor(data?: IExamCountPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["driveItemIds"])) {
                this.driveItemIds = [] as any;
                for (let item of _data["driveItemIds"])
                    this.driveItemIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ExamCountPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExamCountPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.driveItemIds)) {
            data["driveItemIds"] = [];
            for (let item of this.driveItemIds)
                data["driveItemIds"].push(item);
        }
        return data;
    }
}

export interface IExamCountPostModel {
    driveItemIds?: string[] | undefined;
}

export class ExamDataRowResultModel implements IExamDataRowResultModel {
    id?: number;
    userId?: string | undefined;
    orderNumber?: number;
    username?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    examId?: number;
    cells?: ExamDataCellResultModel[] | undefined;

    constructor(data?: IExamDataRowResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.orderNumber = _data["orderNumber"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.examId = _data["examId"];
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(ExamDataCellResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamDataRowResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDataRowResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["orderNumber"] = this.orderNumber;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["examId"] = this.examId;
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExamDataRowResultModel {
    id?: number;
    userId?: string | undefined;
    orderNumber?: number;
    username?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    examId?: number;
    cells?: ExamDataCellResultModel[] | undefined;
}

export class ExamDataCellResultModel implements IExamDataCellResultModel {
    id?: number;
    generatedName?: string | undefined;
    value?: number;
    examDataRowId?: number;

    constructor(data?: IExamDataCellResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.generatedName = _data["generatedName"];
            this.value = _data["value"];
            this.examDataRowId = _data["examDataRowId"];
        }
    }

    static fromJS(data: any): ExamDataCellResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDataCellResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["generatedName"] = this.generatedName;
        data["value"] = this.value;
        data["examDataRowId"] = this.examDataRowId;
        return data;
    }
}

export interface IExamDataCellResultModel {
    id?: number;
    generatedName?: string | undefined;
    value?: number;
    examDataRowId?: number;
}

export class ExamPDFsFolderExistsResponseModel implements IExamPDFsFolderExistsResponseModel {
    exists?: boolean;
    folderPath?: string | undefined;

    constructor(data?: IExamPDFsFolderExistsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exists = _data["exists"];
            this.folderPath = _data["folderPath"];
        }
    }

    static fromJS(data: any): ExamPDFsFolderExistsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExamPDFsFolderExistsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        data["folderPath"] = this.folderPath;
        return data;
    }
}

export interface IExamPDFsFolderExistsResponseModel {
    exists?: boolean;
    folderPath?: string | undefined;
}

export class ExamCreatedResultModel implements IExamCreatedResultModel {
    id?: number;

    constructor(data?: IExamCreatedResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExamCreatedResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExamCreatedResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IExamCreatedResultModel {
    id?: number;
}

export class ExamPostModel implements IExamPostModel {
    id?: number;
    name!: string;
    groupId!: string;
    date!: Date;
    startTime!: string;
    duration!: string;
    worksheet!: string;
    status?: ExamStatus;
    startedAt?: Date | undefined;
    firstRow!: number;
    stepSize!: number;
    introductionTemplate?: string | undefined;
    autoStart?: boolean;
    autoEnd?: boolean;
    exercises?: ExercisePostModel[] | undefined;
    gradingTolerance!: number;
    flowsheetsDriveId!: string;
    fileDriveId!: string;
    userId?: string | undefined;
    createdAt?: Date;
    isDeleted?: boolean;

    constructor(data?: IExamPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.groupId = _data["groupId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.startTime = _data["startTime"];
            this.duration = _data["duration"];
            this.worksheet = _data["worksheet"];
            this.status = _data["status"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.firstRow = _data["firstRow"];
            this.stepSize = _data["stepSize"];
            this.introductionTemplate = _data["introductionTemplate"];
            this.autoStart = _data["autoStart"];
            this.autoEnd = _data["autoEnd"];
            if (Array.isArray(_data["exercises"])) {
                this.exercises = [] as any;
                for (let item of _data["exercises"])
                    this.exercises!.push(ExercisePostModel.fromJS(item));
            }
            this.gradingTolerance = _data["gradingTolerance"];
            this.flowsheetsDriveId = _data["flowsheetsDriveId"];
            this.fileDriveId = _data["fileDriveId"];
            this.userId = _data["userId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ExamPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExamPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["groupId"] = this.groupId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["startTime"] = this.startTime;
        data["duration"] = this.duration;
        data["worksheet"] = this.worksheet;
        data["status"] = this.status;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["firstRow"] = this.firstRow;
        data["stepSize"] = this.stepSize;
        data["introductionTemplate"] = this.introductionTemplate;
        data["autoStart"] = this.autoStart;
        data["autoEnd"] = this.autoEnd;
        if (Array.isArray(this.exercises)) {
            data["exercises"] = [];
            for (let item of this.exercises)
                data["exercises"].push(item.toJSON());
        }
        data["gradingTolerance"] = this.gradingTolerance;
        data["flowsheetsDriveId"] = this.flowsheetsDriveId;
        data["fileDriveId"] = this.fileDriveId;
        data["userId"] = this.userId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IExamPostModel {
    id?: number;
    name: string;
    groupId: string;
    date: Date;
    startTime: string;
    duration: string;
    worksheet: string;
    status?: ExamStatus;
    startedAt?: Date | undefined;
    firstRow: number;
    stepSize: number;
    introductionTemplate?: string | undefined;
    autoStart?: boolean;
    autoEnd?: boolean;
    exercises?: ExercisePostModel[] | undefined;
    gradingTolerance: number;
    flowsheetsDriveId: string;
    fileDriveId: string;
    userId?: string | undefined;
    createdAt?: Date;
    isDeleted?: boolean;
}

export class ExercisePostModel implements IExercisePostModel {
    id?: number;
    order?: number;
    subExerciseOrder?: number | undefined;
    examId?: number;
    template?: string | undefined;
    inputParameters?: ExerciseInputParameterPostModel[] | undefined;
    outputParameters?: ExerciseOutputParameterPostModel[] | undefined;

    constructor(data?: IExercisePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.subExerciseOrder = _data["subExerciseOrder"];
            this.examId = _data["examId"];
            this.template = _data["template"];
            if (Array.isArray(_data["inputParameters"])) {
                this.inputParameters = [] as any;
                for (let item of _data["inputParameters"])
                    this.inputParameters!.push(ExerciseInputParameterPostModel.fromJS(item));
            }
            if (Array.isArray(_data["outputParameters"])) {
                this.outputParameters = [] as any;
                for (let item of _data["outputParameters"])
                    this.outputParameters!.push(ExerciseOutputParameterPostModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExercisePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExercisePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["subExerciseOrder"] = this.subExerciseOrder;
        data["examId"] = this.examId;
        data["template"] = this.template;
        if (Array.isArray(this.inputParameters)) {
            data["inputParameters"] = [];
            for (let item of this.inputParameters)
                data["inputParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.outputParameters)) {
            data["outputParameters"] = [];
            for (let item of this.outputParameters)
                data["outputParameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExercisePostModel {
    id?: number;
    order?: number;
    subExerciseOrder?: number | undefined;
    examId?: number;
    template?: string | undefined;
    inputParameters?: ExerciseInputParameterPostModel[] | undefined;
    outputParameters?: ExerciseOutputParameterPostModel[] | undefined;
}

export class ExerciseInputParameterPostModel implements IExerciseInputParameterPostModel {
    id?: number;
    exerciseId?: number;
    alias?: string | undefined;
    order?: number;
    column?: string | undefined;
    generatedName?: string | undefined;

    constructor(data?: IExerciseInputParameterPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.exerciseId = _data["exerciseId"];
            this.alias = _data["alias"];
            this.order = _data["order"];
            this.column = _data["column"];
            this.generatedName = _data["generatedName"];
        }
    }

    static fromJS(data: any): ExerciseInputParameterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExerciseInputParameterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["exerciseId"] = this.exerciseId;
        data["alias"] = this.alias;
        data["order"] = this.order;
        data["column"] = this.column;
        data["generatedName"] = this.generatedName;
        return data;
    }
}

export interface IExerciseInputParameterPostModel {
    id?: number;
    exerciseId?: number;
    alias?: string | undefined;
    order?: number;
    column?: string | undefined;
    generatedName?: string | undefined;
}

export class ExerciseOutputParameterPostModel implements IExerciseOutputParameterPostModel {
    id?: number;
    exerciseId?: number;
    alias?: string | undefined;
    column?: string | undefined;
    order?: number;
    generatedName?: string | undefined;
    description?: string | undefined;
    points?: number;

    constructor(data?: IExerciseOutputParameterPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.exerciseId = _data["exerciseId"];
            this.alias = _data["alias"];
            this.column = _data["column"];
            this.order = _data["order"];
            this.generatedName = _data["generatedName"];
            this.description = _data["description"];
            this.points = _data["points"];
        }
    }

    static fromJS(data: any): ExerciseOutputParameterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExerciseOutputParameterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["exerciseId"] = this.exerciseId;
        data["alias"] = this.alias;
        data["column"] = this.column;
        data["order"] = this.order;
        data["generatedName"] = this.generatedName;
        data["description"] = this.description;
        data["points"] = this.points;
        return data;
    }
}

export interface IExerciseOutputParameterPostModel {
    id?: number;
    exerciseId?: number;
    alias?: string | undefined;
    column?: string | undefined;
    order?: number;
    generatedName?: string | undefined;
    description?: string | undefined;
    points?: number;
}

export class ExamResultModel implements IExamResultModel {
    id?: number;
    name?: string | undefined;
    groupId?: string | undefined;
    startTime?: string | undefined;
    fileDriveId?: string | undefined;
    fileVersion?: string | undefined;
    endTime?: string | undefined;
    duration?: string | undefined;
    status?: ExamStatus;
    createdAt?: Date;
    date?: Date;
    isDeleted?: boolean;

    constructor(data?: IExamResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.groupId = _data["groupId"];
            this.startTime = _data["startTime"];
            this.fileDriveId = _data["fileDriveId"];
            this.fileVersion = _data["fileVersion"];
            this.endTime = _data["endTime"];
            this.duration = _data["duration"];
            this.status = _data["status"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ExamResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExamResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["groupId"] = this.groupId;
        data["startTime"] = this.startTime;
        data["fileDriveId"] = this.fileDriveId;
        data["fileVersion"] = this.fileVersion;
        data["endTime"] = this.endTime;
        data["duration"] = this.duration;
        data["status"] = this.status;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IExamResultModel {
    id?: number;
    name?: string | undefined;
    groupId?: string | undefined;
    startTime?: string | undefined;
    fileDriveId?: string | undefined;
    fileVersion?: string | undefined;
    endTime?: string | undefined;
    duration?: string | undefined;
    status?: ExamStatus;
    createdAt?: Date;
    date?: Date;
    isDeleted?: boolean;
}

export class ExamListResponseModel implements IExamListResponseModel {
    totalRecords?: number;
    exams?: ExamResultModel[] | undefined;

    constructor(data?: IExamListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["exams"])) {
                this.exams = [] as any;
                for (let item of _data["exams"])
                    this.exams!.push(ExamResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExamListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.exams)) {
            data["exams"] = [];
            for (let item of this.exams)
                data["exams"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExamListResponseModel {
    totalRecords?: number;
    exams?: ExamResultModel[] | undefined;
}

export class ExportExamToJsonPostModel implements IExportExamToJsonPostModel {
    examId!: number;
    filename!: string;
    parentDirectoryUniqueId?: string | undefined;
    conflictAction?: UploadConflictAction | undefined;

    constructor(data?: IExportExamToJsonPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
            this.filename = _data["filename"];
            this.parentDirectoryUniqueId = _data["parentDirectoryUniqueId"];
            this.conflictAction = _data["conflictAction"];
        }
    }

    static fromJS(data: any): ExportExamToJsonPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportExamToJsonPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        data["filename"] = this.filename;
        data["parentDirectoryUniqueId"] = this.parentDirectoryUniqueId;
        data["conflictAction"] = this.conflictAction;
        return data;
    }
}

export interface IExportExamToJsonPostModel {
    examId: number;
    filename: string;
    parentDirectoryUniqueId?: string | undefined;
    conflictAction?: UploadConflictAction | undefined;
}

export enum UploadConflictAction {
    Overwrite = 0,
    KeepBoth = 1,
}

export class CloneExamsResponseModel implements ICloneExamsResponseModel {
    errors?: string[] | undefined;

    constructor(data?: ICloneExamsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): CloneExamsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneExamsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface ICloneExamsResponseModel {
    errors?: string[] | undefined;
}

export class CloneExamsPostModel implements ICloneExamsPostModel {
    fileUniqueId!: string;
    exams?: CloneExamModel[] | undefined;

    constructor(data?: ICloneExamsPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUniqueId = _data["fileUniqueId"];
            if (Array.isArray(_data["exams"])) {
                this.exams = [] as any;
                for (let item of _data["exams"])
                    this.exams!.push(CloneExamModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CloneExamsPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneExamsPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUniqueId"] = this.fileUniqueId;
        if (Array.isArray(this.exams)) {
            data["exams"] = [];
            for (let item of this.exams)
                data["exams"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICloneExamsPostModel {
    fileUniqueId: string;
    exams?: CloneExamModel[] | undefined;
}

export class CloneExamModel implements ICloneExamModel {
    examId!: number;

    constructor(data?: ICloneExamModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
        }
    }

    static fromJS(data: any): CloneExamModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneExamModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        return data;
    }
}

export interface ICloneExamModel {
    examId: number;
}

export class SubmittedExamPostModel implements ISubmittedExamPostModel {
    examId!: number;
    results?: SubmittedExamParameterPostModel[] | undefined;

    constructor(data?: ISubmittedExamPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SubmittedExamParameterPostModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubmittedExamPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubmittedExamPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubmittedExamPostModel {
    examId: number;
    results?: SubmittedExamParameterPostModel[] | undefined;
}

export class SubmittedExamParameterPostModel implements ISubmittedExamParameterPostModel {
    parameterId!: number;
    exerciseId!: number;
    value?: number | undefined;

    constructor(data?: ISubmittedExamParameterPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterId = _data["parameterId"];
            this.exerciseId = _data["exerciseId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SubmittedExamParameterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubmittedExamParameterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterId"] = this.parameterId;
        data["exerciseId"] = this.exerciseId;
        data["value"] = this.value;
        return data;
    }
}

export interface ISubmittedExamParameterPostModel {
    parameterId: number;
    exerciseId: number;
    value?: number | undefined;
}

export class ServiceInformationModel implements IServiceInformationModel {
    buildDate?: string | undefined;
    version?: string | undefined;

    constructor(data?: IServiceInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildDate = _data["buildDate"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ServiceInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildDate"] = this.buildDate;
        data["version"] = this.version;
        return data;
    }
}

export interface IServiceInformationModel {
    buildDate?: string | undefined;
    version?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}